import React from 'react';
import styled from 'styled-components';

export const QuestionExercise = () => {
  return <Container>Question Exercise</Container>;
};

const Container = styled.div`
  width: 100%;
`;
